<div class="container-fluid p-0 profile-page user-management-page">
    <HeaderSection
        :breadcrumb="breadcrumb"
        @breadcrumb-click="handleBreadcrumbClick"
        @open-assistant="showAssistant = true"
    />

    <div class="chatbot-push">
        <section class="container profile-sections user-management-sections py-4">
            <SettingsUserManagementTab :user_profile="user_profile" />
        </section>
    </div>

    <BolideAssistant :is_open="showAssistant" @close-assistant="showAssistant = false" />
</div>
